<template>
  <div id="data-list-list-view" class="data-list-container">

    <div v-if="initProgress" class="w-100 mt-5 mb-5">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>
    <vs-prompt title="Exportar a Excel" class="export-options" @cancle="clearFields" @accept="exportToExcelOrders"
               accept-text="Exportar" cancel-text="Cancelar" @close="clearFields" :active.sync="activePromptOrders">
      <vs-input v-model="fileName" placeholder="Ingresa el nombre del archivo..." class="w-full"/>
      <v-select v-model="selectedFormat" :options="formats" class="my-4"/>
      <div class="flex">
        <span class="mr-4">Auto ajustar columna:</span>
        <vs-switch v-model="cellAutoWidth">Auto ajustar columna</vs-switch>
      </div>
    </vs-prompt>

    <detail @update="updateDateSideBar" :isSidebarActive="updateSidebar" @closeSidebar="updateSidebar = false"
            :data="sidebarData"/>

    <vx-card collapse="false" ref="filterCard" title="Filtros" class="user-list-filters mb-8" collapse-action
             refresh-content-action @refresh="resetFilters">
      <h5 class="mt-5 mb-2">Filtrar por fecha y cliente</h5>

      <div class="vx-row mb-8">
        <div class="vx-col md:w-1/2">
          <h6 class="mt-5 mb-2">Selecciona al cliente</h6>
          <v-select
            @change="list = []"
            :options="clients" :clearable="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="client" class="mb-4 md:mb-0" name="local" id="local"/>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2">
          <flat-pickr :config="configdateTimePicker"
                      v-model="filterData.startDate"
                      placeholder="Desde"
                      class="w-full"/>
        </div>
        <div class="vx-col md:w-1/2">
          <flat-pickr :config="configdateTimePicker"
                      v-model="filterData.endDate"
                      placeholder="Hasta"
                      class="w-full"/>
        </div>
        <div class="vx-col mt-2">
          <vs-button @click="filter('dates')" class="mr-6 vs-align-right">Filtrar</vs-button>
        </div>
      </div>
    </vx-card>

    <div v-if="showGenerateReport" class="dashboard__content">
      <div class="dashboard__card">
        <h2>Costo de envíos</h2>
        <span>{{ 'S/ ' + Intl.NumberFormat('en-US', {}).format(shippingCost) }}</span>
      </div>
      <div class="dashboard__card">
           <h2>Total cobrado</h2>
        <span>{{ 'S/ ' + Intl.NumberFormat('en-US', {}).format(totalToBeCollected) }}</span>
      </div>
      <div class="dashboard__card">
        <h2>Monto depositado</h2>
        <span>{{ 'S/ ' + Intl.NumberFormat('en-US', {}).format(this.totalDeposited) }}</span>
      </div>
      <div class="dashboard__card">
        <h2>Saldo</h2>
        <span>{{ 'S/ ' + Intl.NumberFormat('en-US', {}).format(((totalDeposited - shippingCost) - totalToBeCollected)) }}</span>
      </div>
    </div>

    <vs-table v-model="selected" ref="table" pagination :max-items="itemsPerPage" search
              :data="list">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- Action - dropdown -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-full">
              <span class="mr-2">Acciones</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="activePromptOrders = true">
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Exportar</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-if="showGenerateReport" @click="activePromptOrders = true">
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Generar reporte</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- Items per page -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
              currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ list.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : list.length }} de {{
              queriedItems
              }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="number">Correlativo</vs-th>
        <vs-th sort-key="number">Tienda</vs-th>
        <vs-th sort-key="date">Fecha de recojo</vs-th>
        <vs-th sort-key="subTotal">Fecha de entrega</vs-th>
        <vs-th sort-key="shipping">Costo de envío</vs-th>
        <vs-th sort-key="shipping">Costo extra</vs-th>
        <vs-th sort-key="totalCollect">Total a cobrar</vs-th>
        <vs-th sort-key="adress">Dirección</vs-th>
        <vs-th sort-key="reference">Referencia</vs-th>
        <vs-th sort-key="district">Distrito</vs-th>
        <vs-th sort-key="fullName">Destinatario</vs-th>
        <vs-th sort-key="phone">Teléfono</vs-th>
        <vs-th sort-key="quantity">Cantidad</vs-th>
        <vs-th sort-key="product">Producto</vs-th>
        <vs-th sort-key="notes">Notas</vs-th>
        <vs-th sort-key="state">Estado de entrega</vs-th>
        <vs-th sort-key="dealerName">Motorizado</vs-th>
        <vs-th sort-key="dealerMotive">Motivo</vs-th>
        <vs-th sort-key="dealerComments">Comentarios</vs-th>
        <vs-th sort-key="dealerAccountDetails">Detalle de cuenta</vs-th>
        <vs-th sort-key="dealerTotalAmount">Total cobrado motorizado</vs-th>
        <vs-th sort-key="dealerImages">Fotos de entrega</vs-th>
        <vs-th sort-key="actions">Acciones</vs-th>
      </template>

      <template slot-scope=" {data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.correlative }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.client.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.pickUpDate }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.deadline }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">S/ {{ tr.district.price + tr.type.price }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">S/ {{ tr.extraCost }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">S/ {{ tr.totalToBeCollected }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.address }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.reference }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.district.label }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.fullName }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.phone }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.quantity }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.product }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.notes }}</p>
            </vs-td>

            <vs-td>
              <vs-chip :color="getOrderStatusColor(tr.status)" class="product-order-status">
                {{ getStatusText(tr.status) }}
              </vs-chip>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.dealer ? tr.dealer.dealerName : '-' }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.dealer ? tr.dealer.motive : '-' }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.dealer ? tr.dealer.comments : '-' }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.dealer ? tr.dealer.accountDetails : '-' }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.dealer ? tr.dealer.totalAmount : '-' }}</p>
            </vs-td>

            <vs-td>
              <div v-if="tr.dealer && tr.dealer.deliveryImages && tr.dealer.deliveryImages.length" class="flex gap-1">
                <img
                  v-for="(img, imgIdx) in tr.dealer.deliveryImages"
                  :key="imgIdx"
                  :src="img"
                  class="h-10 w-10 rounded object-cover cursor-pointer"
                  @click="openUrl(img)"
                />
              </div>
              <span v-else-if="tr.dealer && tr.dealer.deliveryImage">
                <img
                  :src="tr.dealer.deliveryImage"
                  class="h-10 w-10 rounded object-cover cursor-pointer"
                  @click="openUrl(tr.dealer.deliveryImage)"
                />
              </span>
              <span v-else>-</span>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon title="Editar" icon="EyeIcon" svgClasses="w-5 h-5 mr-2 hover:text-primary stroke-current"
                            @click.stop="sidebarData = tr, updateSidebar = true"/>

              <feather-icon
                v-if="tr.deliveryImage"
                @click="openUrl(tr.deliveryImage)"
                icon="ExternalLinkIcon"
                svgClasses="h-4 w-4"/>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import moment from "moment"

import vSelect from 'vue-select'
import { db, Timestamp } from '@/firebase/firebaseConfig'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Detail from "@/views/shipments/Detail.vue";

let _ = require('lodash')

export default {
  components: {
    Detail,
    vSelect,
    flatPickr
  },
  data() {
    return {
      selected: null,
      itemsPerPage: 20,
      isMounted: false,
      list: [],
      clients: [],
      client: null,
      showGenerateReport: false,
      initProgress: false,
      //Filters
      showFilter: false,
      filterData: {
        startDate: moment(new Date()).format('YYYY-MM-DD'),
        endDate: moment(new Date()).format('YYYY-MM-DD'),
      },
      // Date
      configdateTimePicker: {
        dateFormat: 'Y-m-d'
      },
      // Data Sidebar
      updateSidebar: false,
      sidebarData: {},
      // Export
      fileName: '',
      formats: ['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      activePrompt: false,
      activePromptOrders: false,
      // Totals
      shippingCost: 0,
      totalToBeCollected: 0,
      totalDeposited: 0,
      balance: 0
    }
  },
  async created() {
    try {
      await this.filter('today')
      await this.loadClients()
    } catch (e) {
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    } finally {
      this.initProgress = false
    }
  },
  mounted() {
    this.isMounted = true
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.list.length
    }
  },
  methods: {
    /**
     * Filter
     * @param type
     * @returns {Promise<void>}
     */
    async filter(type) {
      try {
        this.initProgress = true
        this.showGenerateReport = false
        this.list = []
        this.totalDeposited = 0
        this.totalToBeCollected = 0
        this.shippingCost = 0
        this.balance = 0
        const orders = []

        // Set start date
        let startDate = new Date()
        let endDate = new Date()
        startDate.setHours(0)
        startDate.setMinutes(0)
        startDate.setSeconds(0)
        // Set end date
        endDate.setHours(23)
        endDate.setMinutes(59)
        endDate.setSeconds(0)

        let startTimes = null
        let endTimes = null
        // End

        if (type === 'today') {
          startTimes = Timestamp.fromDate(startDate)
          endTimes = Timestamp.fromDate(endDate)
        }
        else if (type === 'tomorrow') {
          startDate.setDate((new Date()).getDate() + 1)
          endDate.setDate((new Date()).getDate() + 1)
          startTimes = Timestamp.fromDate(startDate)
          endTimes = Timestamp.fromDate(endDate)
        }
        else if (type === 'dates') {
          startDate = new Date(this.filterData.startDate + ' 05:00:00')
          startDate.setHours(0)
          startDate.setMinutes(0)
          startDate.setSeconds(0)

          endDate = new Date(this.filterData.endDate + ' 05:00:00')
          endDate.setHours(23)
          endDate.setMinutes(59)
          endDate.setSeconds(0)

          startTimes = Timestamp.fromDate(startDate)
          endTimes = Timestamp.fromDate(endDate)
        }

        let querySnapshot = null

        if (!this.client) {
          querySnapshot = await db.collection('detail')
            .where('deadline', '>=', startTimes)
            .where('deadline', '<=', endTimes)
            .orderBy('deadline', 'asc')
            .get()
        } else {
          querySnapshot = await db.collection('detail')
            .where('deadline', '>=', startTimes)
            .where('deadline', '<=', endTimes)
            .where('client.id', '==', this.client.id)
            .orderBy('deadline', 'asc')
            .get()

          // Get orders
          const querySnapshotOrders = await db.collection('orders')
            .where('createdAt', '>=', startTimes)
            .where('createdAt', '<=', endTimes)
            .where('client.id', '==', this.client.id)
            .get()

          querySnapshotOrders.forEach((doc) => {
            orders.push({
              id: doc.id,
              total: doc.data().total
            })
            console.log("Entra orders")
            console.log(this.totalDeposited)

            this.totalDeposited += doc.data().total
          })
          // End

          this.showGenerateReport = true
        }

        querySnapshot.forEach((doc) => {
          const obj = {
            ...doc.data(),
            pickUpDate: doc.data().pickUpDate.toDate(),
            deadline: doc.data().deadline.toDate(),
            createdAt: doc.data().createdAt.toDate(),
            status: doc.data().status ? doc.data().status : 'hold',
            extraCost: doc.data().extraCost ? doc.data().extraCost : 0
          }

          obj.id = doc.id

          obj.pickUpDate = moment(obj.pickUpDate).format('YYYY-MM-DD')
          obj.deadline = moment(obj.deadline).format('YYYY-MM-DD')
          obj.createdAt = moment(obj.createdAt).format('YYYY-MM-DD HH:mm')

          this.list.push({
            ...obj
          })

          // Sum totals
          if(doc.data().status === 'confirmed'){
            this.shippingCost += (obj.district.price + obj.type.price)
            this.totalToBeCollected += obj.totalToBeCollected ? obj.totalToBeCollected : 0
          }
          // End
        })
      } catch(e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
        this.showGenerateReport = false
      } finally {
        this.initProgress = false
      }
    },
    /**
     * Reset filters
     * @returns {Promise<void>}
     */
    async resetFilters() {
      try {
        this.initProgress = true
        this.client = null
        await this.filter('today')

        this.$refs.filterCard.removeRefreshAnimation()
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    },
    /**
     * Get order state color
     * @param status
     * @returns {string}
     */
    getOrderStateColor(status) {
      if (status) return 'dark'
      else return 'danger'
    },
    /**
     * Get order status color
     * @param status
     * @returns {string}
     */
    getOrderStatusColor(status) {
      if (status === 'hold') return 'dark'
      else if (status === 'confirmed') return 'green'
      else if (status === 'done') return 'green'
      else if (status === 'rejected') return 'danger'
      else if (status === 'rejectedWithCharge') return 'danger'
      else if (status === 'canceled') return 'danger'
      else if (status === 'canceledWithCharge') return 'danger'
      else if (status === 'rescheduledWithoutCharge') return 'warning'
      else if (status === 'rescheduledWithCharge') return 'warning'
    },
    /**
     * Get state text
     * @param value
     * @returns {string}
     */
    getStateText(value) {
      if (value) return 'Validado'
      else return 'Por validar'
    },
    /**
     * Get status text
     */
    getStatusText(value) {
      if (value === 'hold') return 'Sin confirmar'
      else if (value === 'confirmed') return 'Recogido'
      else if (value === 'done') return 'Entregado'
      else if (value === 'canceled') return 'Anulado'
      else if (value === 'canceledWithCharge') return 'Anulado con cobro'
      else if (value === 'rejected') return 'Rechazado'
      else if (value === 'rejectedWithCharge') return 'Rechazado con cobro'
      else if (value === 'rescheduledWithoutCharge') return 'Reprogramado sin cobro'
      else if (value === 'rescheduledWithCharge') return 'Reprogramado con cobro'
    },
    async exportToExcelOrders() {
      try {
        this.initProgress = true
        let list = _.cloneDeep(this.list)

        let headerTitle = ['N° DE ORDEN', 'CORRELATIVO', 'TIENDA', 'FECHA DE RECOJO', 'FECHA DE ENTREGA', 'TIPO DE SERVICIO', 'DIRECCION DE ENTREGA Y REFERENCIA', 'DISTRITO', 'UBICACION URL (OPCIONAL)', 'DESTINATARIO', 'TELÉFONO', 'COSTO DE ENVIO S/', 'COSTO EXTRA S/.', 'DESCRIPCION PRODUCTO', 'CANTIDAD', 'TOTAL A COBRAR', 'NOTAS ENTREGA', 'ESTADO']
        let headerVal = ['index', 'correlative', 'client', 'pickUpDate', 'deadline', 'type', 'address', 'districtLabel', 'location', 'fullName', 'phone', 'price', 'extraCost', 'product', 'quantity', 'totalToBeCollected', 'notes', 'status']
        import('@/vendor/Export2Excel').then(async excel => {
          list.forEach((obj, index) => {
            obj.index = index + 1
            obj.correlative = obj.correlative ? obj.correlative : '-'
            obj.client = obj.client.name
            obj.price = obj.district.price + obj.type.price
            obj.type = obj.type.label
            obj.districtLabel = obj.district.label
            obj.address = obj.address + '/' + obj.reference
            obj.status = this.getStatusText(obj.status)
          })
          const data = this.formatJson(headerVal, list)
          excel.export_json_to_excel({
            header: headerTitle,
            data,
            filename: this.fileName,
            autoWidth: this.cellAutoWidth,
            bookType: this.selectedFormat
          })
          this.clearFields()
        })

        if (this.showGenerateReport) {
          const batch = db.batch()
          this.list.forEach((o) => {
            o.includedInReport = true
            batch.update(db.collection('detail').doc(o.id), {
              includedInReport: 'confirmed'
            })
          })

          await batch.commit()
          this.showGenerateReport = false

          this.$vs.notify({
            color: 'success',
            title: 'Envíos',
            text: 'Reporte generado correctamente'
          })

          this.initProgress = false
        } else {
          this.initProgress = false
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
        this.initProgress = false
      }
    },
    /**
     * Clear fields
     */
    clearFields() {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    /**
     * Get clients of firestore
     * @returns {Promise<void>}
     */
    async loadClients() {
      this.initProgress = true
      const querySnap = await db.collection('clients').orderBy('createdAt', 'desc').get()
      querySnap.forEach((doc) => {
        let client = {
          id: doc.id,
          document: doc.data().document,
          typeDocument: doc.data().typeDocument,
          businessName: doc.data().businessName,
          label: doc.data().businessName + ' - ' + doc.data().document
        }
        this.clients.push(client)
      })
      this.initProgress = false
    },
    /**
     * Update data of sidebar
     * */
    updateDateSideBar(o) {
      const index = this.list.findIndex((d) => d.id === o.id)
      Object.assign(this.list[index], o)
    },
    /**
     * Open url
     * @param link
     */
    openUrl (link) {
      open(link, '_blank')
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
